export default __webpack_public_path__ + "static/media/1af647d322be102a9c3f59b46aee8b45.svg";